<div class="wrapper wrapper-content animated fadeInRight">
  <div class="row">
    <div class="col-lg-12">
      <div class="top-bar-actions">
        <div class="action-group">
          <label for="courseSelector">Course:</label>
          <select
            id="courseSelector"
            class="form-control form-control-inline"
            [disabled]="state().isLoading"
            [value]="selectedRoundTournamentCourseId() ?? ''"
            (change)="onCourseSelected(+$any($event.target).value)"
          >
            @for (course of state().availableCourses; track
            course.roundTournamentCourseId) {
            <option [value]="course.roundTournamentCourseId">
              {{ course.courseName }}
            </option>
            }
          </select>
          <span class="text-muted small">
            (RTC ID: {{ selectedRoundTournamentCourseId() ?? "—" }})
          </span>
          <button
            class="btn btn-info btn-sm"
            (click)="onCopyFromPrevious()"
            [disabled]="!canCopyFromPrevious()"
          >
            <i class="fa fa-copy"></i> Copy Pairings from Previous Round
          </button>
        </div>

        <div class="action-group reports-group">
          <label for="reportSelector">Reports:</label>
          <select
            id="reportSelector"
            class="form-control form-control-inline"
            [ngModel]="selectedReport()"
            (ngModelChange)="onReportChange($event)"
          >
            @for (option of reportOptions; track option.id) {
            <option [value]="option.id">{{ option.label }}</option>
            }
          </select>
          <button
            class="btn btn-white btn-sm"
            (click)="onPrintSelectedReport()"
            [disabled]="state().isLoading"
          >
            <i class="fa fa-print"></i> Print
          </button>
        </div>

        <div class="action-group publish-group">
          <button
            class="btn btn-primary btn-sm"
            (click)="onPublish()"
            [disabled]="state().isLoading || !hasBlocks()"
          >
            <i class="fa fa-upload"></i>
            {{ isPairingsPublished() ? "Re-Publish" : "Publish" }}
          </button>
          <span class="publish-status">
            @if (hasPublishTimestamp()) {
            <i class="fa fa-clock-o"></i> Published At:
            {{ lastPublishedAt() | date : "M/d/yyyy h:mm a" }}
            } @else {
            <i class="fa fa-info-circle"></i> Not Published }
          </span>
        </div>
      </div>
    </div>
  </div>

  @if (state().error) {
  <div class="row">
    <div class="col-lg-12">
      <div class="alert alert-danger m-b-sm">
        <strong>Error:</strong> {{ state().error }}
      </div>
    </div>
  </div>
  }

  <div class="row">
    <div class="col-lg-12">
      <div class="ibox pairings-settings" [class.collapsed]="!showSettings()">
        <div
          class="ibox-title"
          (click)="toggleSettings()"
          (keydown.enter)="toggleSettings()"
          (keydown.space)="toggleSettings()"
          role="button"
          tabindex="0"
        >
          <h5><i class="fa fa-cog"></i> Group Creation and Pairings Tools</h5>
          <div class="ibox-tools">
            <a class="collapse-link" [attr.aria-label]="showSettings() ? 'Collapse settings' : 'Expand settings'">
              <i
                class="fa"
                [ngClass]="showSettings() ? 'fa-chevron-circle-up' : 'fa-chevron-circle-down'"
              ></i>
            </a>
          </div>
        </div>
        <div
          class="ibox-content"
          [style.display]="showSettings() ? 'block' : 'none'"
        >
          @if (state().selectedRoundTournamentCourseId) {
          <app-pairing-settings
            [roundTournamentCourseId]="state().selectedRoundTournamentCourseId!"
          />
          } @else {
          <div class="alert alert-warning m-b-none">
            Select a course to load pairing settings.
          </div>
          }

          <div class="row m-t-md">
            <div class="col-lg-12 text-right">
              <button
                class="btn btn-white"
                (click)="onClear()"
                [disabled]="state().isLoading || !hasBlocks()"
              >
                <i class="fa fa-trash"></i> Clear Blocks &amp; Groups
              </button>
              <button
                class="btn btn-white"
                (click)="onClearSlots()"
                [disabled]="state().isLoading || !hasBlocks()"
              >
                <i class="fa fa-eraser"></i> Clear Player Assignments
              </button>
              <button
                class="btn btn-success"
                (click)="onGenerate()"
                [disabled]="
                  state().isGenerating ||
                  !state().selectedRoundTournamentCourseId
                "
              >
                <i class="fa fa-magic"></i> Generate Pairings
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  @if (hasBlocks()) {
  <div class="row summary-row">
    <div class="col-lg-12">
      <div class="alert alert-info">
        <strong>{{ courseSummaryLabel() }}</strong>
        &nbsp;|&nbsp; Blocks: {{ blocks().length }} &nbsp;|&nbsp; Groups:
        {{ totalGroups() }} &nbsp;|&nbsp; Assigned Players:
        {{ totalPlayers() }} &nbsp;|&nbsp; Available Players:
        {{ availablePlayerCount() }}
      </div>
    </div>
  </div>
  }

  <div class="row">
    <div class="col-lg-12">
      <div class="content-split">
        <div class="groups-section">
          <div class="ibox">
            <div class="ibox-title">
              <h5>Groups &amp; Pairings</h5>
              <div class="ibox-tools">
                @if (availablePlayerCount() === 0 && hasBlocks()) {
                <span class="label label-primary">All Players Assigned</span>
                } @else if (hasBlocks()) {
                <span class="label label-warning"
                  >{{ availablePlayerCount() }} Players Unassigned</span
                >
                }
              </div>
            </div>
            <div class="ibox-content">
              @if (state().isLoading) {
              <div class="loading-container">
                <div class="sk-spinner sk-spinner-wave">
                  <div class="sk-rect1"></div>
                  <div class="sk-rect2"></div>
                  <div class="sk-rect3"></div>
                  <div class="sk-rect4"></div>
                  <div class="sk-rect5"></div>
                </div>
              </div>
              } @else if (hasBlocks()) {
              <div class="table-responsive groups-table">
                <table class="table table-striped table-bordered">
                  <thead>
                    <tr>
                      <th>Grp</th>
                      <th>Tee</th>
                      <th>Tee Time</th>
                      <th>W</th>
                      <th>B</th>
                      @for (slotNumber of slotNumbers(); track slotNumber) {
                      <th>Player {{ slotNumber }}</th>
                      }
                      <th>Type</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (block of blocks(); track block.blockId ??
                    block.number; let blockIndex = $index) {
                    <tr class="block-header">
                      <td [attr.colspan]="tableColumnCount() + 1">
                        {{ formatBlockHeader(block, blockIndex) }}
                      </td>
                    </tr>
                    @for (group of block.groups ?? []; track group.groupId ??
                    group.number; let groupIndex = $index) {
                    <tr
                      [ngClass]="groupRowClasses(blockIndex, group.groupType)"
                    >
                      <td>{{ group.number ?? "—" }}</td>
                      <td>{{ group.startTee ?? "—" }}</td>
                      <td>{{ formatTime(group.startTime) }}</td>
                      <td>{{ block.wave ?? "—" }}</td>
                      <td>{{ block.number ?? blockIndex + 1 }}</td>
                      @for (slotNumber of slotNumbers(); track slotNumber) {
                      <td class="player-cell">
                        @if (getSlot(group, slotNumber); as slot) {
                        <div class="player-name">
                          {{ slot.playerName ?? "—" }}
                        </div>
                        @if (slot.playerClassification) {
                        <span class="label label-default">{{
                          slot.playerClassification
                        }}</span>
                        } } @else {
                        <span class="text-muted">—</span>
                        }
                      </td>
                      }
                      <td class="group-type-cell">
                        @if (displayGroupType(group.groupType); as groupType) {
                        <span class="badge">{{ groupType }}</span>
                        } @else {
                        <span class="text-muted">—</span>
                        }
                      </td>
                    </tr>
                    } }
                  </tbody>
                </table>
              </div>
              } @else {
              <div class="empty-state text-center">
                <i class="fa fa-users fa-2x text-muted"></i>
                <p class="m-t-sm text-muted">
                  No pairings generated for the selected course.
                </p>
                <p class="text-muted">
                  Click <strong>Generate Pairings</strong> to build tee sheets
                  once settings are saved.
                </p>
              </div>
              }
            </div>
          </div>
        </div>

        <div class="sidebar-section">
          <div class="ibox">
            <div class="ibox-content">
              <div class="tabs-container">
                <ul class="nav nav-tabs">
                  <li [class.active]="activeTab() === 'available'">
                    <a (click)="setActiveTab('available')"
                      >Available Players
                      <span class="label label-warning">{{
                        availablePlayerCount()
                      }}</span></a
                    >
                  </li>
                  <li [class.active]="activeTab() === 'alpha'">
                    <a (click)="setActiveTab('alpha')">Pairings by Alpha</a>
                  </li>
                  <li [class.active]="activeTab() === 'swap'">
                    <a (click)="setActiveTab('swap')">Swap</a>
                  </li>
                </ul>
                <div class="tab-content">
                  @if (activeTab() === 'available') {
                  <div class="tab-pane active">
                    <div class="panel-body">
                      @if (hasAvailablePlayers()) {
                      <ul class="list-group available-player-list">
                        @for (player of availablePlayers(); track
                        player.scorecardId ?? player.playerName) {
                        <li class="list-group-item">
                          <span>{{ player.playerName }}</span>
                          @if (player.playerClassification) {
                          <span class="badge">{{
                            player.playerClassification
                          }}</span>
                          }
                        </li>
                        }
                      </ul>
                      } @else {
                      <div class="alert alert-success text-center m-b-none">
                        <i class="fa fa-check-circle fa-2x"></i>
                        <p class="m-t-sm">
                          <strong>All players assigned!</strong>
                        </p>
                      </div>
                      }
                    </div>
                  </div>
                  } @if (activeTab() === 'alpha') {
                  <div class="tab-pane active">
                    <div class="panel-body">
                      <app-pairings-alpha-list
                        [players]="alphaPlayers()"
                        [hasBlocks]="hasBlocks()"
                        [isLoading]="state().isLoading"
                      />
                    </div>
                  </div>
                  } @if (activeTab() === 'swap') {
                  <div class="tab-pane active">
                    <div class="panel-body">
                      <app-pairings-swap />
                    </div>
                  </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
